import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Crown, ArrowRight, X } from 'lucide-react';
import { useState } from 'react';

export default function UpgradeBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState(false);

  // Only show for Standard plan users
  if (!user || user.plan !== 'standard' || dismissed) {
    return null;
  }

  return (
    <div className="relative overflow-hidden rounded-xl border border-amber-500/30 bg-gradient-to-r from-amber-600/20 via-amber-500/15 to-orange-600/20 p-4 mb-6 animate-in fade-in slide-in-from-top-2">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-amber-600/10 to-orange-600/10 blur-xl" />
      
      <div className="relative flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="w-10 h-10 rounded-full bg-amber-600/30 flex items-center justify-center flex-shrink-0 ring-2 ring-amber-500/50">
            <Crown className="w-5 h-5 text-amber-300" />
          </div>
          <div className="flex-1">
            <h3 className="text-sm font-semibold text-white mb-0.5">
              Unlock More Agents & Premium Features
            </h3>
            <p className="text-xs text-slate-300">
              Upgrade to Premium for 5 agents, better accent quality, and no call duration limits
            </p>
          </div>
        </div>
        
        <div className="flex items-center gap-2">
          <button
            onClick={() => navigate('/dashboard/settings?tab=billing')}
            className="px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-semibold rounded-lg flex items-center gap-2 transition-all shadow-lg hover:shadow-xl group"
          >
            Upgrade Now
            <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
          </button>
          <button
            onClick={() => setDismissed(true)}
            className="w-8 h-8 rounded-lg bg-white/5 hover:bg-white/10 flex items-center justify-center transition-colors"
            aria-label="Dismiss"
          >
            <X className="w-4 h-4 text-slate-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
